"use client";

import staticData from "@/public/data/profile/modal.json";
import Box from "@/shared/components/common/Box";
import DropdownMenu, { DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/shared/components/common/drop-down";
import Flex from "@/shared/components/common/Flex";
import { Sheet, SheetContent, SheetTrigger } from "@/shared/components/common/sheet";
import Typography from "@/shared/components/common/Typography";
import { useDeviceType } from "@/shared/context/DeviceContext";
import { SignOut, User, Wallet } from "@phosphor-icons/react";
import Link from "next/link";
import { type ReactNode, useState } from "react";
interface ProfileModalProps {
  children: ReactNode;
  profileData: ProfileResult;
  logoutAction: () => void;
}
export default function ProfileModal({
  children,
  profileData,
  logoutAction
}: ProfileModalProps) {
  const [open, setOpen] = useState(false);
  const {
    account,
    logout
  } = staticData.body.sections;
  return useDeviceType() === "mobile" ? <Sheet open={open} onOpenChange={() => setOpen(prev => !prev)} data-sentry-element="Sheet" data-sentry-component="ProfileModal" data-sentry-source-file="ProfileModal.tsx">
      <SheetTrigger data-sentry-element="SheetTrigger" data-sentry-source-file="ProfileModal.tsx">{children}</SheetTrigger>
      <SheetContent className="bg-background" side="top" data-sentry-element="SheetContent" data-sentry-source-file="ProfileModal.tsx">
        <Flex className="flex-col gap-y-4 py-4 pt-5" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="ProfileModal.tsx">
            <Flex className="justify-between items-center gap-x-2" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
              <Wallet className="w-6 h-6 text-foreground" data-sentry-element="Wallet" data-sentry-source-file="ProfileModal.tsx" />
              <Flex className="gap-x-2" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
                <Typography data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{profileData.currency_name}</Typography>
                <Typography data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{profileData.fund.toLocaleString()}</Typography>
              </Flex>
            </Flex>
          </Box>

          <Box data-sentry-element="Box" data-sentry-source-file="ProfileModal.tsx">
            <Link className="w-full" href={"/profile/account"} data-sentry-element="Link" data-sentry-source-file="ProfileModal.tsx">
              <Flex className="w-full justify-between items-center gap-x-2 h-10" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
                <User className="w-5 h-5 text-foreground" data-sentry-element="User" data-sentry-source-file="ProfileModal.tsx" />
                <Typography className="font-medium" data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{account.title}</Typography>
              </Flex>
            </Link>
          </Box>

          <Flex className="w-full justify-between items-center gap-x-2 h-10" onClick={logoutAction} data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
            <SignOut className="w-5 h-5 text-red-800" data-sentry-element="SignOut" data-sentry-source-file="ProfileModal.tsx" />
            <Typography variant="body2" className="font-medium text-red-800" data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">
              {logout.title}
            </Typography>
          </Flex>
        </Flex>
      </SheetContent>
    </Sheet> : <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="ProfileModal" data-sentry-source-file="ProfileModal.tsx">
      <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="ProfileModal.tsx">{children}</DropdownMenuTrigger>
      <DropdownMenuContent className="w-52 rounded-xs shadow-1" data-sentry-element="DropdownMenuContent" data-sentry-source-file="ProfileModal.tsx">
        <DropdownMenuLabel data-sentry-element="DropdownMenuLabel" data-sentry-source-file="ProfileModal.tsx">
          <Flex className="justify-between items-center gap-x-2" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
            <Flex className="gap-x-2" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
              <Typography data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{profileData.currency_name}</Typography>
              <Typography data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{profileData.fund.toLocaleString()}</Typography>
            </Flex>
            <Wallet className="w-6 h-6 text-foreground" data-sentry-element="Wallet" data-sentry-source-file="ProfileModal.tsx" />
          </Flex>
        </DropdownMenuLabel>
        <DropdownMenuSeparator data-sentry-element="DropdownMenuSeparator" data-sentry-source-file="ProfileModal.tsx" />
        {/* Account */}
        <DropdownMenuCheckboxItem className="rounded-xs !px-2" data-sentry-element="DropdownMenuCheckboxItem" data-sentry-source-file="ProfileModal.tsx">
          <Link className="w-full" href={"/profile/account"} data-sentry-element="Link" data-sentry-source-file="ProfileModal.tsx">
            <Flex className="w-full justify-between items-center gap-x-2" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
              <Typography className="font-medium" data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{account.title}</Typography>
              <User className="w-5 h-5 text-foreground" data-sentry-element="User" data-sentry-source-file="ProfileModal.tsx" />
            </Flex>
          </Link>
        </DropdownMenuCheckboxItem>
        {/* Logout */}
        <DropdownMenuCheckboxItem className="rounded-xs !px-2" onClick={logoutAction} data-sentry-element="DropdownMenuCheckboxItem" data-sentry-source-file="ProfileModal.tsx">
          <Flex className="w-full justify-between items-center gap-x-2" data-sentry-element="Flex" data-sentry-source-file="ProfileModal.tsx">
            <Typography className="font-medium" data-sentry-element="Typography" data-sentry-source-file="ProfileModal.tsx">{logout.title}</Typography>
            <SignOut className="w-5 h-5 text-foreground" data-sentry-element="SignOut" data-sentry-source-file="ProfileModal.tsx" />
          </Flex>
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>;
}